// extracted by mini-css-extract-plugin
export default {"main":"FinancialLiteracy_main__IipDo"};